import React from "react";
import Teleprompter from "./Teleprompter";


function App() {
  return <Teleprompter />;
}

export default App;
